"use client";

type RouterRef = {
  push: (path: string) => void;
};

let _router: RouterRef | null = null;

/**
 * Registra a instância do router do Next.js para uso fora de componentes React
 */
export function setAppRouter(router: RouterRef) {
  _router = router;
}

/**
 * Navega para o caminho informado usando o router do Next.js
 */
export function navigateTo(path: string) {
  _router?.push(path);
}
